function BarraDeProgresso({ step }) {
  if ([1, 6].includes(step)) {
    return null;
  }

  const titulos = {
    1: "",
    2: "2/5 - informe seus documentos pessoais",
    3: "3/5 – Informe suas características pessoais ",
    4: "4/5 – Confirme seu e-mail.",
    5: "5/5 – Conheça um pouco sobre o PT",
  };

  return (
    <div>
      <div style={{ color: "#4e4e4e", fontSize: "0.9rem" }}>
        {titulos[step]} 
      </div>
      <div className="progressoFiliacao">
        <div className={`passo ${step === 1 ? "ativo" : ""}`}></div>
        <div className={`passo ${step === 2 ? "ativo" : ""}`}></div>
        <div className={`passo ${step === 3 ? "ativo" : ""}`}></div>
        <div className={`passo ${step === 4 ? "ativo" : ""}`}></div>
        <div className={`passo ${step === 5 ? "ativo" : ""}`}></div>
      </div>
    </div>
  );
}

export default BarraDeProgresso;
